import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

/**
 * This function replaces normalText with matching strings in hightlightText and
 * returns a new text component comprised of the existing text and the replaced
 * Hightlight Component
 * @param {string} color the color of the highlight
 * @param {function} Component text component to render
 * @param {string} normalText the string to display
 * @param {string} highlightText string of replacement words
 **/
const highlight = (color, Component, normalText, highlightText) => {
  const Highlight = styled(Component)`
    border: none;
    color: ${p => (p.theme.color[color] ? p.theme.color[color] : color)};
    display: inline;
    margin: 0px;
    padding: 0px;
  `;

  // create array of normal words
  const normal = normalText.split(' ').reverse();

  // create an array of words and filter out empty strings
  highlightText
    .split(' ')
    .filter(Boolean)
    /* iterate over the highLight words and replace the normal word
        with the highlight component at the index the highlight word is
        found in the array of normal text */
    .map(
      (highlightWord, index) =>
        normal.includes(highlightWord) &&
        normal.splice(
          normal.findIndex(
            normalWord =>
              typeof normalWord === 'string' &&
              normalWord.toUpperCase() === highlightWord.toUpperCase()
          ),
          1,
          <Highlight key={index}>{`${highlightWord} `}</Highlight>
        )
    );

  return normal
    .reverse()
    .map(word => (typeof word === 'string' ? `${word} ` : word));
};

const TextHighlight = ({
  color = 'primary',
  Component,
  highlightText,
  text
}) => <Component>{highlight(color, Component, text, highlightText)}</Component>;

TextHighlight.propTypes = {
  color: PropTypes.string,
  Component: PropTypes.func.isRequired,
  highlightText: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default TextHighlight;
